import { createGlobalStyle } from "styled-components";

export const GlobalListStyled = createGlobalStyle`
    .list-group {
        border-radius: 16px;
    }

    .list-group-item,
    .list-group-item:hover,
    .list-group-item:active,
    .list-group-item:focus,
    .list-group-item-action,
    .list-group-item-action:hover,
    .list-group-item-action:focus,
    .list-group-item-action:active {
        background: var(--color-button-secondary-default);
        color: var(--color-label-primary);
        padding: 12px 16px;
        font-weight: 400;
    }
`;